import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import IntroSection from './components/IntroSection';
import TestimonialsSection from './components/TestimonialsSection';
import LocationSection from './components/LocationSection';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'About Us | Local Hair Experts in Otley | Riverdale Hair Studio';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Meet the team at Riverdale Hair Studio, your trusted local hair salon in Otley. We pride ourselves on personalised service, expert styling, and being part of the West Yorkshire community since 2018.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <IntroSection />
        <TestimonialsSection />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;